import React from 'react'
import Footer from './Footer';
import Navbar from './Navbar';
import Subscribe from './Subscribe';

function FAQ(){
  return (
    <>
    <div>
        <Navbar />

        <div className="container py-5">
        <div className="col py-5">
          <div className="col py-3 text-center">
            <p className="fs-1">FAQS</p>
          </div>

          <div className="col text-center">
            <div className="row py-1">
              <div className="col-6 py-2">
                <div className="col text-start">
                  <p className="fs-3">HOW CAN I INVEST IN YOUR STARTUP?</p>
                </div>
                <div className="col text-start">
                  <p>
                    Please send us an email at admin@vertoxlabs.com if you need
                    to get in touch with us for our pitch deck and take the
                    conversation forward
                  </p>
                </div>
              </div>
              <div className="col-6 py-2">
                <div className="col text-start">
                  <p className="fs-3">DO YOU HAVE INTERN POSITIONS?</p>
                </div>

                <div className="col text-start">
                  <p>
                    We'll be happy to consider interns if your aspirations and
                    career objectives are tied to the domain of sustainability
                    and circularity. Please send an email to us at
                    admin@vertoxlabs.com with the subject "Intern looking for
                    opportunities"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Subscribe />
    <Footer />
    </>
  )
}

export default FAQ;
